import { InjectionToken } from '@angular/core';
import { ILocale, ILocaleDateFormats } from './i18n.types';

export const DEFAULT_LANG = new InjectionToken<string>('DEFAULT_LANG');
export const DEFAULT_LOCALE = new InjectionToken<string>('DEFAULT_LOCALE');
export const LOCALES = new InjectionToken<ILocale[]>('LOCALES');
export const LOCALE_DATE_FORMATS = new InjectionToken<ILocaleDateFormats>('LOCALE_DATE_FORMATS');

export const I18N_SERVER_DATE_FORMAT = 'YYYY-MM-DD';
export const I18N_SERVER_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
